var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMoneyForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.71 20.22 5.5-5.5c.01-.01.02-.01.03-.02-.63-.44-1.4-.7-2.24-.7-2.21 0-4 1.79-4 4 0 .75.21 1.46.58 2.06l.12.18c.007-.007.01-.013.01-.02zM8.28 15.78l-5.5 5.5c-.01.01-.02.01-.03.02.64.44 1.41.7 2.25.7 1.46 0 2.73-.78 3.42-1.94.37-.6.58-1.31.58-2.06 0-.84-.26-1.61-.7-2.25-.01.01-.01.02-.02.03z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4C4 4 2 5.5 2 9v3.56c0 .37.38.6.71.45.98-.45 2.11-.62 3.3-.41 2.63.47 4.56 2.91 4.49 5.58-.01.42-.07.83-.18 1.23-.08.31.17.6.49.6H17c3 0 5-1.5 5-5V9c0-3.5-2-5-5-5H7zm2.5 8a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1-5 0zm9 2.75c-.41 0-.75-.34-.75-.75v-4c0-.41.34-.75.75-.75s.75.34.75.75v4c0 .41-.34.75-.75.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMoneyForbidden);
export default __webpack_public_path__ + "static/media/vuesax-bold-money-forbidden.84aed65f1bf6046255e817556fa025a6.svg";
export { ForwardRef as ReactComponent };